import React, { useEffect, useRef, useState } from "react";
import { Swiper, SwiperSlide } from "swiper/react";
import "swiper/css";
import "./Latest_Blog.css";
import Blog_outer_card from "../../../Common-Component/Blog_outer_card/Blog_outer_card";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { faAngleLeft, faAngleRight } from "@fortawesome/free-solid-svg-icons";
import { getlatestblog } from "../../../../features/blog/Slice";
import { useDispatch, useSelector } from "react-redux";
import  parse  from "html-react-parser";

function Latest_Blog() {

  const latestblog = useSelector((state) => state.blog.addLatestblog);
  const dispatch = useDispatch();
 

  useEffect(() => {
           dispatch(getlatestblog());
         }, [dispatch]);



  const swiperRef = useRef(null);
  const [swiperInstance, setSwiperInstance] = useState(null);

  // const blogPosts = [
  //   {
  //     imgSrc: "/assets/Images/Blog/Blog_outer/Blog_img_1.png",
  //     innerText: "How to Choose the Best Standard Business Card for Your Needs",
  //     date: "22 Nov 2024",
  //     description:
  //       "A business card is more than just a piece of paper—it’s a reflection of your brand and professionalism. Choosing the right business card can make a lasting impression & help you stand out. In this guide, we’ll walk you through the key factors to...",
  //   },
  //   {
  //     imgSrc: "/assets/Images/Blog/Blog_outer/Blog_img_2.png",
  //     innerText: "How to Choose the Best Standard Business Card for Your Needs",
  //     date: "22 Nov 2024",
  //     description:
  //       "A business card is more than just a piece of paper—it’s a reflection of your brand and professionalism. Choosing the right business card can make a lasting impression & help you stand out. In this guide, we’ll walk you through the key factors to...",
  //   },
  //   {
  //     imgSrc: "/assets/Images/Blog/Blog_outer/Blog_img_3.png",
  //     innerText: "How to Choose the Best Standard Business Card for Your Needs",
  //     date: "22 Nov 2024",
  //     description:
  //       "A business card is more than just a piece of paper—it’s a reflection of your brand and professionalism. Choosing the right business card can make a lasting impression & help you stand out. In this guide, we’ll walk you through the key factors to...",
  //   },
  //   {
  //     imgSrc: "/assets/Images/Blog/Blog_outer/Blog_img_4.png",
  //     innerText: "How to Choose the Best Standard Business Card for Your Needs",
  //     date: "22 Nov 2024",
  //     description:
  //       "A business card is more than just a piece of paper—it’s a reflection of your brand and professionalism. Choosing the right business card can make a lasting impression & help you stand out. In this guide, we’ll walk you through the key factors to...",
  //   },
  //   {
  //     imgSrc: "/assets/Images/Blog/Blog_outer/Blog_img_1.png",
  //     innerText: "How to Choose the Best Standard Business Card for Your Needs",
  //     date: "22 Nov 2024",
  //     description:
  //       "A business card is more than just a piece of paper—it’s a reflection of your brand and professionalism. Choosing the right business card can make a lasting impression & help you stand out. In this guide, we’ll walk you through the key factors to...",
  //   },
  // ];

  const handleMainSliderClick = (direction) => {
   

    if (swiperInstance) {
      if (direction === "prev") {
        swiperInstance.slidePrev();
      } else if (direction === "next") {
        swiperInstance.slideNext();
      }
    }
  };

  return (
    <section className="Latest_Blog">
      <div className="heading_btn_holder">
        <div className="Heading_holder">
          <h4>Latest Blog</h4>
        </div>

        <div className="btn_backgound_holder">
          <div className="silder-btn">
            <div className="back_btn_holder">
              <div
                className="back-btn"
                onClick={() => handleMainSliderClick("prev")}
              >
                <p>
                  {" "}
                  <FontAwesomeIcon icon={faAngleLeft} />
                </p>
              </div>
            </div>
            <div className="next_btn_holder">
              <div
                className="next-btn"
                onClick={() => handleMainSliderClick("next")}
              >
                <p>
                  {" "}
                  <FontAwesomeIcon icon={faAngleRight} />
                </p>
              </div>
            </div>
          </div>
        </div>
      </div>

      <Swiper
        className="mySwiper Latest_Blog_slider"
        onSwiper={(swiper) => setSwiperInstance(swiper)}
        breakpoints={{
          0: { slidesPerView: 1, spaceBetween: 10 }, // Mobile
          321: { slidesPerView: 1, spaceBetween: 10 }, // Mobile
          375: { slidesPerView: 1.5, spaceBetween: 10 }, // Mobile
          640: { slidesPerView: 2, spaceBetween: 20 }, // Tablets
          768: { slidesPerView: 2.5, spaceBetween: 20 }, // Tablets
          1024: { slidesPerView: 3.1, spaceBetween: 30 }, // Laptops
          1280: { slidesPerView: 3.5, spaceBetween: 40 }, // Desktops
        }}
      >
        {latestblog?.data?.map((post, index) => (
          <SwiperSlide key={index}>
            {" "}
            <Blog_outer_card
            post={post.id}
              imgSrc={process.env.REACT_APP_IMG_URL + post?.image}
              innerText={post.name}
              date={post.createdAt}
              description={parse(post.description) || ""}
            />
          </SwiperSlide>
        ))}
      </Swiper>
    </section>
  );
}

export default Latest_Blog;
